import { render, staticRenderFns } from "./TimeCountdown.vue?vue&type=template&id=5d6bcd99&scoped=true"
import script from "./TimeCountdown.vue?vue&type=script&lang=js"
export * from "./TimeCountdown.vue?vue&type=script&lang=js"
import style0 from "./TimeCountdown.vue?vue&type=style&index=0&id=5d6bcd99&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6bcd99",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6bcd99')) {
      api.createRecord('5d6bcd99', component.options)
    } else {
      api.reload('5d6bcd99', component.options)
    }
    module.hot.accept("./TimeCountdown.vue?vue&type=template&id=5d6bcd99&scoped=true", function () {
      api.rerender('5d6bcd99', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/ContactVerification/components/TimeCountdown.vue"
export default component.exports